<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <div @click="close" class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <form
      @submit.prevent="create"
      class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
    >
      <div class="mt-3 text-center sm:mt-0 sm:text-left">
        <h3 class="text-lg leading-6 text-gray-900">Kategorie hinzufügen</h3>
        <div class="mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
          <basic-input
            class="sm:col-span-3"
            v-model="category.title"
            label="Name"
            placeholder="z.B. Freie Platzwahl"
          />
          <basic-input
            v-model="category.count"
            class="sm:col-span-3"
            label="Kontingent"
            placeholder="z.B. 100"
            type="number"
          />
        </div>
      </div>
      <div class="mt-5 sm:flex">
        <basic-button
          class="w-full sm:w-auto"
          button-class="w-full justify-center"
          type="submit"
          color="green"
          :disabled="!category.title || !(category.count > 0)"
        >Anlegen</basic-button>
        <basic-button
          class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-3 sm:w-auto"
          button-class="w-full justify-center"
          @click="close()"
          color="white"
        >Abbrechen</basic-button>
      </div>
    </form>
  </div>
</template>


<script>
export default {
  props: {
    createFunc: {
      required: true,
      type: Function
    }
  },

  data() {
    return {
      category: {
        title: "",
        count: null
      }
    };
  },
  methods: {
    create() {
      this.createFunc(this.category);
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>